<script setup>
import { defineProps } from 'vue';
import tiaLogo from '@/assets/tia-affiliation-logo.png';
import triumphPayLogo from '@/assets/triumphPay-affiliation-logo.png';
import highwayLogo from '@/assets/highway-logo-2.svg';
import VerifiedIcon from '@/components/VerifiedIcon.vue';

defineProps({
  logoSrc: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  isVerified: {
    type: Boolean,
    required: true,
  },
  customLogoClass: {
    type: String,
    default: '',
  },
});

const logoMap = {
  tia: tiaLogo,
  triumphPay: triumphPayLogo,
  highway: highwayLogo,
};
</script>

<template>
  <section
    class="card-background flex flex-row justify-between rounded-md p-4"
    style="height: 52px"
  >
    <img
      :class="customLogoClass"
      :src="logoMap[logoSrc]"
      alt="Affiliation logo"
    />
    <div class="flex items-center gap-2">
      <span class="text-xs text-body-color">{{ label }}</span>
      <VerifiedIcon :is-verified="isVerified" />
    </div>
  </section>
</template>

<style scoped>
.card-background {
  background-color: #fafafa;
}
</style>
